// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import keys from "../utils/keys";

export const chatApi = createApi({
  reducerPath: "chatApi",
  baseQuery: fetchBaseQuery({ baseUrl: keys.baseUrl }),
  tagTypes: ["refreshThreadList", "refreshThreadMetadata"],
  endpoints: (builder) => ({
    sendMessage: builder.mutation({
      query: (body) => ({
        url: "hiiboai/chat",
        method: "POST",
        body: body,
      }),
      transformResponse: (response: any) => {
        return response;
      },
    }),
    stopMessage: builder.mutation({
      query: (username) => ({
        url: `hiiboai/abort-stream/${username}`,
        method: "POST",
      }),
      transformResponse: (response: any) => {
        return response;
      },
    }),
    fileUpload: builder.mutation({
      query: (body) => ({
        url: "files/upload",
        method: "POST",
        body: body,
      }),
      transformResponse: (response: any) => {
        return response;
      },
    }),
    createThread: builder.mutation({
      query: (body) => ({
        url: "hiiboai/createthread",
        method: "POST",
        body: body,
      }),
      transformResponse: (response: any) => {
        return response;
      },
    }),
    generateThread: builder.mutation({
      query: (body) => ({
        url: "hydrate/generate-thread",
        method: "POST",
        body: body,
      }),
      transformResponse: (response: any) => {
        return response;
      },
    }),
    generateSummary: builder.mutation({
      query: (body) => ({
        url: "hiiboai/getllmthreadsummary",
        method: "POST",
        body: body,
      }),
      transformResponse: (response: any) => {
        return response;
      },
    }),
    deleteThread: builder.mutation({
      query: (params) => ({
        url: "hiiboai/deleteConversation" + params,
        method: "DELETE",
      }),
      invalidatesTags: ["refreshThreadList"],
      transformResponse: (response: any) => {
        return response;
      },
    }),
    hydrateThread: builder.mutation({
      query: (body) => ({
        url: "hiiboai/hydratethread",
        method: "POST",
        body: body,
      }),
      transformResponse: (response: any) => {
        return response;
      },
    }),
    switchLlm: builder.mutation({
      query: (body) => ({
        url: "hiiboai/llmhydratethread",
        method: "POST",
        body: body,
      }),
      transformResponse: (response: any) => {
        return response;
      },
    }),
    updateThreadMetadata: builder.mutation({
      query: (body) => ({
        url: "hydrate/metadata",
        method: "PUT",
        body: body,
      }),
      invalidatesTags: ["refreshThreadMetadata"],
      transformResponse: (response: any) => {
        return response;
      },
    }),
    searchMessages: builder.query({
      query: (params) => ({
        url: `hiiboai/searchMessages?user_id=${params.userId}&query=${params.query}`,
        method: "GET",
      }),
      transformResponse: (response: any) => {
        return response;
      },
    }),
    syncMessages: builder.query({
      query: (params) => ({
        url: `sync/messages?userId=${params.userId}&limit=20000`,
        method: "GET",
      }),
      transformResponse: (response: any) => {
        return response;
      },
    }),
    getPreviousSearch: builder.query({
      query: (params) => ({
        url: `/hiiboai/searchHistory/${params.searchType}?user_id=${params.userId}`,
        method: "GET",
      }),
      transformResponse: (response: any) => {
        return response;
      },
    }),
    getUserConversations: builder.query({
      query: (userId) => ({
        url: `hiiboai/GetConversationByUserId?user_id=${userId}`,
        method: "GET",
      }),
      transformResponse: (response: any) => {
        return response;
      },
      providesTags: ["refreshThreadList"],
    }),
    hydrateMasterValues: builder.query({
      query: () => ({
        url: `hydrate/master-values`,
        method: "GET",
      }),
      transformResponse: (response: any) => {
        return response;
      },
    }),
    getConversationById: builder.query({
      query: (params) => ({
        url: `hiiboai/GetChatByConversationId${params}`,
        method: "GET",
      }),
      transformResponse: (response: any) => {
        return response;
      },
    }),
    getThreadMetadata: builder.query({
      query: (params) => ({
        url: `hydrate/metadata${params}`,
        method: "GET",
      }),
      providesTags: ["refreshThreadMetadata"],
      transformResponse: (response: any) => {
        return response;
      },
    }),
  }),
});
export const {
  useSendMessageMutation,
  useGetUserConversationsQuery,
  useGetConversationByIdQuery,
  useSearchMessagesQuery,
  useGenerateSummaryMutation,
  useFileUploadMutation,
  useCreateThreadMutation,
  useGenerateThreadMutation,
  useGetThreadMetadataQuery,
  useUpdateThreadMetadataMutation,
  useHydrateThreadMutation,
  useHydrateMasterValuesQuery,
  useDeleteThreadMutation,
  useSyncMessagesQuery,
  useGetPreviousSearchQuery,
  useSwitchLlmMutation,
  useStopMessageMutation
} = chatApi;
